import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

import { Link } from 'react-router-dom';
import { imageUrl } from '../../Constants/contant';

function TourOne({ categories }) {
  return (
    <>
      {/* =========================
          CUSTOM CSS
      ========================== */}
      <style>{`
        /* Slider Navigation Bottom */
        .tour-slider-btn {
          display: flex;
          justify-content: center;
          gap: 14px;
          margin-top: 35px;
        }

        .tour-action .th-btn {
  background: #F8CE50 !important;
  color: #000 !important;
  border: 1px solid #F8CE50 !important;
}

.tour-action .th-btn:hover {
  background: #000 !important;
  color: #fff !important;
  border: 1px solid #000 !important;
}

.tour-action .th-btn::before,
.tour-action .th-btn::after {
  display: none !important;
}

        .tour-slider-btn button {
          width: 52px;
          height: 52px;
          border: none;
          border-radius: 50%;
          background: #F8CE50;
          color: #000;
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 8px 20px rgba(0,0,0,0.12);
          transition: all 0.3s ease;
          cursor: pointer;
        }

        /* Hover White */
        .tour-slider-btn button:hover {
          background: #fff;
          color: #000;
          transform: translateY(-3px);
        }

        .tour-slider-btn button i {
          font-size: 16px;
        }

        /* Tour Card */
        .tour-box {
          border-radius: 16px;
          overflow: hidden;
          background: #fff;
          box-shadow: 0 5px 20px rgba(0,0,0,0.08);
          transition: all 0.3s ease;
          height: 100%;
        }

        .tour-box:hover {
          transform: translateY(-6px);
        }

        .tour-box_img img {
          width: 100%;
          height: 260px;
          object-fit: cover;
        }

        .tour-content {
          padding: 20px;
        }

        .box-title {
          font-size: 20px;
          margin-bottom: 10px;
        }

        .box-title a {
          color: #111;
          text-decoration: none;
          transition: 0.3s;
        }

        .box-title a:hover {
          color: #F8CE50;
        }

        .tour-rating {
          margin-bottom: 10px;
          color: #777;
          font-size: 14px;
        }

        .tour-box_price {
          font-size: 24px;
          font-weight: 700;
          color: #111;
          margin-bottom: 15px;
        }

        .tour-action {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          margin-top: 15px;
        }

        .tour-action span {
          color: #666;
          font-size: 14px;
          display: flex;
          align-items: center;
        }

        .tour-action span i {
          margin-right: 6px;
        }

        /* Book Now Button */
        .tour-book-btn {
          background: #F8CE50 !important;
          color: #000 !important;
          border: none;
          padding: 11px 18px;
          border-radius: 8px;
          font-weight: 600;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
          min-width: 120px;
        }

        /* Hover White */
        .tour-book-btn:hover {
          background: #fff !important;
          color: #000 !important;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0,0,0,0.15);
        }

        .tour-book-btn:focus,
        .tour-book-btn:active {
          background: #F8CE50 !important;
          color: #000 !important;
          box-shadow: none !important;
        }

        /* REMOVE DOTS */
        .swiper-pagination {
          display: none !important;
        }

        /* Mobile Responsive */
        @media (max-width: 768px) {
          .tour-box_img img {
            height: 220px;
          }

          .tour-slider-btn button {
            width: 42px;
            height: 42px;
            font-size: 14px;
          }

          .tour-action {
            flex-direction: column;
            align-items: flex-start;
          }

          .tour-book-btn {
            width: 100%;
          }
            
        }
      `}</style>

      <section
        className="tour-area position-relative bg-top-center overflow-hidden space bg-no-repeat"
        id="service-sec"
      >
        {categories?.map((category) => (
          <div
            className="container position-relative"
            id={`category-${category.id}`}
            key={category.id}
          >
            {/* Category Heading */}
            <div className="row mt-5">
              <div className="col-lg-6 offset-lg-3">
                <div className="title-area text-center">
                  <h2 className="sec-title">{category.name}</h2>
                </div>
              </div>
            </div>

            {/* Slider */}
            <div className="slider-area tour-slider position-relative">
              <Swiper
                modules={[Navigation]}
                navigation={{
                  prevEl: `.tour-prev-${category.id}`,
                  nextEl: `.tour-next-${category.id}`,
                }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  576: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 2 },
                  1200: { slidesPerView: 3 },
                  1400: { slidesPerView: 4 },
                }}
                spaceBetween={24}
                grabCursor={true}
                className="swiper th-slider has-shadow slider-drag-wrap"
              >
                {category.products && category.products.length > 0 ? (
                  category.products.map((product) => (
                    <SwiperSlide key={product.id}>
                      <div className="tour-box">
                        <Link to={`/service-details/${product.id}`}>
                          <div className="tour-box_img">
                            <img
                              src={
                                product.image
                                  ? imageUrl + product.image
                                  : '/assets/img/default.jpg'
                              }
                              alt={product.name}
                            />
                          </div>
                        </Link>

                        <div className="tour-content">
                          <h3 className="box-title">
                            <Link to={`/service-details/${product.id}`}>
                              {product.name}
                            </Link>
                          </h3>

                           <div className="tour-rating">
                            <div className="star-rating" role="img">
                              <span style={{ width: '100%' }}>
                                Rated{' '}
                                <strong className="rating">5.00</strong> out of
                                5
                              </span>
                            </div>
                          </div>

                          <h4 className="tour-box_price">
                            {product.price
                              ? `₹${product.price}`
                              : 'Price on Request'}
                          </h4>

                          <div className="tour-action">
                            <span>
                              <i className="fa-light fa-clock"></i>
                              {product.day || '5 Days'}
                            </span>

                            <Link
                              to="/contact"
                              className="th-btn style"
                            >
                              Book Now
                            </Link>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))
                ) : (
                  <p className="text-center">
                    No tours found for this category.
                  </p>
                )}
              </Swiper>

              {/* Bottom Navigation Buttons */}
              <div className="tour-slider-btn">
                <button className={`tour-prev-${category.id}`}>
                  <i className="fa-solid fa-arrow-left"></i>
                </button>

                <button className={`tour-next-${category.id}`}>
                  <i className="fa-solid fa-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>
        ))}
      </section>
    </>
  );
}

export default TourOne;